import React, { useEffect, useState } from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => {

  const [active1, setActive1] = useState(false);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setActive1(true)
      setTimeout(() => {
        setActive2(true)
        setTimeout(()=>{
          setActive3(true)
        },600)
      }, 500);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='app__header app__wrapper section__padding' id='home'>
      <div className='app__wrapper_info'>
        <SubHeading title="Implementing The Beauty of The Goddess" />
        <h1 className='app__header-h1'>
          <p className={active1 ? "header-animation" : "header-1"}>GODDESS</p>
          <p className={active2 ? "header-animation" : "header-2"}>LUXURIOUS</p>
          <p className={active3 ? "header-animation" : "header-3"}>ACCESSORIES</p>
        </h1>
        <p className='p__opensans app__header-p' style={{margin: '2rem 0'}}>In Greek mythology, Elpis (Ancient Greek: ἐλπίς) is the spirit of hope. She was depicted as a young woman, usually carrying flowers or a cornucopia in her hands.</p>
        <button type="button" className="custom__button">Explore Products</button>
      </div>

    
    </div>
  );
}

export default Header;
